

import React, { useEffect, useRef, useState, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { motion, AnimatePresence } from "framer-motion"
import { AuthContext } from "./AuthContext"
import { FaComments, FaFolderOpen, FaCheckSquare, FaSearch } from "react-icons/fa"
import {
  BookOpen,
  Brain,
  Calculator,
  BarChartIcon as ChartBar,
  CheckCircle,
  Clock,
  Globe,
  GraduationCap,
  Lightbulb,
  MessageCircle,
  PieChart,
  Rocket,
  Star,
  Target,
  TrendingUp,
  Users,
  Zap,
  Award,
  BarChart3,
  BookMarked,
  Cpu,
  Database,
  FileText,
  Layers,
  Monitor,
  Network,
  Puzzle,
  Shield,
  Sparkles,
  Trophy,
  Wand2,
} from "lucide-react"
import { Helmet } from "react-helmet"
const isMobile = () => window.innerWidth / window.innerHeight < 1.0

const MathPlatformIntro = () => {
  const [scrollDirection, setScrollDirection] = useState("down")
  const [lastScrollY, setLastScrollY] = useState(0)
  const [visibleSections, setVisibleSections] = useState(Array(6).fill(false))
  const sectionRefs = useRef([])
  const { guestLogin } = useContext(AuthContext)
  const [showIntroDetail, setShowIntroDetail] = useState(() => !isMobile())

  const navigate = useNavigate()

  const handleGuestLogin = async (e) => {
    e.preventDefault()
    try {
      const success = await guestLogin()
      if (success) {
        navigate("/home", { replace: true })
      } else {
        console.error("Guest login failed")
      }
    } catch (error) {
      console.error("Guest login error:", error)
    }
  }


    const handleGuestLoginChat = async (e) => {
    e.preventDefault()
    try {
      const success = await guestLogin()
      if (success) {
        navigate("/chatbox", { replace: true })
      } else {
        console.error("Guest login failed")
      }
    } catch (error) {
      console.error("Guest login error:", error)
    }
  }

    const handleGuestLoginPapers = async (e) => {
    e.preventDefault()
    try {
      const success = await guestLogin()
      if (success) {
        navigate("/past-papers", { replace: true })
      } else {
        console.error("Guest login failed")
      }
    } catch (error) {
      console.error("Guest login error:", error)
    }
  }

    const handleGuestLoginGrader = async (e) => {
    e.preventDefault()
    try {
      const success = await guestLogin()
      if (success) {
        navigate("/exam-grader", { replace: true })
      } else {
        console.error("Guest login failed")
      }
    } catch (error) {
      console.error("Guest login error:", error)
    }
  }

    const handleGuestLoginQuiz = async (e) => {
    e.preventDefault()
    try {
      const success = await guestLogin()
      if (success) {
        navigate("/quiz-generator", { replace: true })
      } else {
        console.error("Guest login failed")
      }
    } catch (error) {
      console.error("Guest login error:", error)
    }
  }
  useEffect(() => {
    const handleResize = () => {
      setShowIntroDetail(!isMobile())
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const [visible, setVisible] = useState([false, false, false, false])
  const [techCardsVisible, setTechCardsVisible] = useState([false, false, false, false])
  const textRefs = useRef([])
  const techCardRefs = useRef([])

  // Initialize refs array
  useEffect(() => {
    sectionRefs.current = Array(6)
      .fill()
      .map((_, i) => sectionRefs.current[i] || React.createRef())
  }, [])

  // Set up scroll direction detection and intersection observer
  useEffect(() => {
    // Scroll direction detection
    const handleScroll = () => {
      const currentScrollY = window.scrollY

      if (currentScrollY > lastScrollY) {
        setScrollDirection("down")
      } else if (currentScrollY < lastScrollY) {
        setScrollDirection("up")
      }

      setLastScrollY(currentScrollY)
    }

    // Intersection observer for section visibility
    const observerOptions = {
      root: null,
      rootMargin: "-20% 0px -20% 0px",
      threshold: 0.1,
    }

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        const index = sectionRefs.current.findIndex((ref) => ref.current === entry.target)

        if (index !== -1) {
          setVisibleSections((prev) => {
            const newState = [...prev]
            newState[index] = entry.isIntersecting
            return newState
          })
        }
      })
    }

    const observer = new IntersectionObserver(observerCallback, observerOptions)

    // Observe all section refs
    sectionRefs.current.forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current)
      }
    })

    window.addEventListener("scroll", handleScroll)

    // Make first section visible by default
    setVisibleSections((prev) => {
      const newState = [...prev]
      newState[0] = true
      return newState
    })

    return () => {
      window.removeEventListener("scroll", handleScroll)
      sectionRefs.current.forEach((ref) => {
        if (ref.current) {
          observer.unobserve(ref.current)
        }
      })
    }
  }, [lastScrollY])

  useEffect(() => {
    const handleScroll = () => {
      setVisible((prev) => {
        const newVisible = [...prev]
        textRefs.current.forEach((el, index) => {
          if (el) {
            // Get the element's bounding rectangle
            const rect = el.getBoundingClientRect()
            // Calculate the vertical center of the element
            const elementCenter = rect.top + rect.height / 2
            // Calculate lower and upper bounds as 20% and 80% of the viewport height
            const lowerBound = window.innerHeight * 0.3
            const upperBound = window.innerHeight * 0.7
            // Update visibility: true if center is within the bounds, false otherwise
            newVisible[index] = elementCenter >= lowerBound && elementCenter <= upperBound
          }
        })
        return newVisible
      })

      setTechCardsVisible((prev) => {
        const newVisible = [...prev]
        techCardRefs.current.forEach((el, index) => {
          if (el) {
            const rect = el.getBoundingClientRect()
            const elementCenter = rect.top + rect.height / 2
            const lowerBound = window.innerHeight * 0.2
            const upperBound = window.innerHeight * 0.8
            newVisible[index] = elementCenter >= lowerBound && elementCenter <= upperBound
          }
        })
        return newVisible
      })
    }

    // Listen for scroll events
    window.addEventListener("scroll", handleScroll)
    // Check initial position on mount
    handleScroll()

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  // Updated sections with the four new functions
  const sections = [
    {
      name: "Chatbox",
      path: "/chatbox",
      icon: FaComments,
      gradient: "from-blue-500 via-indigo-500 to-red-500",
      description: "AI-powered instant help for all your questions",
      content:
        "Experience revolutionary AI-powered assistance that understands your A-level, AP, and IB coursework challenges. Our advanced chatbox provides instant, personalized support for complex mathematical concepts, scientific theories, and academic problems. Whether you're struggling with calculus derivatives, organic chemistry mechanisms, or AP physics equations, our intelligent system delivers step-by-step explanations tailored to A-level, AP, and IB curriculum standards. The chatbox integrates seamlessly with your study workflow, offering 24/7 academic support that adapts to your learning pace and style.",
      features: [
        "Instant A-level, AP, and IB curriculum support",
        "Advanced natural language processing for complex queries",
        "Step-by-step problem-solving guidance",
        "Multi-subject expertise across all A-level, AP, and IB courses",
      ],
      decorativeIcon: MessageCircle,
    },
    {
      name: "Past Papers",
      path: "/past-papers",
      icon: FaFolderOpen,
      gradient: "from-emerald-500 via-teal-500 to-cyan-500",
      description: "Access comprehensive exam archives",
      content:
        "Unlock the most extensive collection of A-level, AP, and IB past papers, meticulously organized and digitally enhanced for optimal learning. Our comprehensive archive spans decades of examination materials, providing authentic practice opportunities that mirror real A-level, AP, and IB testing conditions. Each past paper comes with detailed marking schemes, examiner reports, and AI-generated insights that highlight common pitfalls and success strategies. Students can filter papers by subject, year, exam board, and difficulty level, ensuring targeted preparation for their specific A-level, AP, or IB examinations.",
      features: [
        "Extensive A-level, AP, and IB past paper database",
        "Interactive marking schemes and solutions",
        "Examiner insights and performance analytics",
        "Customizable practice sessions by topic and difficulty",
      ],
      decorativeIcon: FileText,
    },
    {
      name: "Exam Grader",
      path: "/exam-grader",
      icon: FaCheckSquare,
      gradient: "from-orange-500 via-red-500 to-red-500",
      description: "Automated assessment and feedback",
      content:
        "Transform your assessment experience with cutting-edge AI technology that provides instant, accurate grading for A-level, AP, and IB practice tests. Our sophisticated exam grader utilizes advanced machine learning algorithms trained on thousands of A-level, AP, and IB marking schemes to deliver consistent, fair, and detailed feedback. The system recognizes various answer formats, mathematical notation, and scientific diagrams, providing comprehensive evaluation that matches professional examiner standards. Students receive immediate performance insights, identifying strengths and areas for improvement across all A-level, AP, and IB subjects.",
      features: [
        "Instant grading for A-level, AP, and IB practice tests",
        "Detailed feedback with improvement suggestions",
        "Performance tracking and progress analytics",
        "Recognition of multiple answer formats and notations",
      ],
      decorativeIcon: CheckCircle,
    },
    {
      name: "Quiz Generator",
      path: "/quiz-generator",
      icon: FaSearch,
      gradient: "from-violet-500 via-indigo-500 to-indigo-500",
      description: "Create personalized practice tests",
      content:
        "Generate unlimited, personalized quizzes tailored specifically to A-level, AP, and IB curriculum requirements using our advanced AI quiz generation system. This innovative tool creates unique practice questions that adapt to your learning progress, focusing on areas where you need the most improvement. The quiz generator draws from extensive databases of A-level, AP, and IB content, ensuring questions align perfectly with examination standards and learning objectives. Each generated quiz includes varied question types, from multiple choice to extended response, mimicking the format and complexity of actual A-level, AP, and IB examinations.",
      features: [
        "Unlimited personalized A-level, AP, and IB quiz generation",
        "Adaptive difficulty based on performance",
        "Comprehensive question type variety",
        "Curriculum-aligned content for all A-level, AP, and IB subjects",
      ],
      decorativeIcon: Puzzle,
    },
  ]

  const lines = ["Artificial Intelligence", "Integrated", "All-Purpose", "Teaching Platform"]

  // Cutting-edge technology description cards
  const techCards = [
    {
      title: "Neural Network Architecture",
      description:
        "Our platform leverages advanced deep learning neural networks specifically trained on A-level, AP, and IB curriculum data. These sophisticated AI models understand the nuanced requirements of A-level mathematics, sciences, and AP coursework, providing contextually aware assistance that adapts to individual learning patterns and academic progression.",
      icon: Brain,
      bgIcon: Network,
    },
    {
      title: "Natural Language Processing",
      description:
        "State-of-the-art NLP technology enables seamless communication between students and our AI systems. Whether you're asking about A-level calculus concepts or AP chemistry reactions, our advanced language models interpret complex academic queries and provide precise, curriculum-specific responses tailored to A-level, AP, and IB examination standards.",
      icon: MessageCircle,
      bgIcon: Wand2,
    },
    {
      title: "Machine Learning Analytics",
      description:
        "Powerful machine learning algorithms continuously analyze student performance across A-level, AP, and IB subjects, identifying learning patterns and predicting areas of difficulty. This intelligent system personalizes the educational experience, optimizing study paths for maximum A-level, AP, and IB examination success through data-driven insights.",
      icon: BarChart3,
      bgIcon: TrendingUp,
    },
    {
      title: "Cloud Computing Infrastructure",
      description:
        "Our robust cloud-based architecture ensures seamless access to A-level, AP, and IB resources from anywhere, anytime. High-performance computing clusters process complex mathematical calculations, generate dynamic visualizations, and deliver instant feedback, supporting thousands of concurrent A-level, AP, and IB students worldwide.",
      icon: Database,
      bgIcon: Monitor,
    },
  ]

  // Stats section data
  const stats = [
    { number: "50,000+", label: "Active Students", icon: Users },
    { number: "1,000+", label: "Past Papers", icon: FileText },
    { number: "95%", label: "Success Rate", icon: Trophy },
    { number: "24/7", label: "AI Support", icon: Clock },
  ]

  // Feature highlights
  const featureHighlights = [
    { icon: Rocket, title: "Lightning Fast", description: "Instant responses to your queries" },
    { icon: Shield, title: "Secure & Private", description: "Your data is protected and encrypted" },
    { icon: Globe, title: "Global Access", description: "Available worldwide, anytime" },
    { icon: Award, title: "Expert Verified", description: "Content reviewed by education professionals" },
  ]

  // Get animation class based on visibility and scroll direction
  const getAnimationClass = (index, isVisible) => {
    if (!isVisible) {
      return scrollDirection === "down" ? "-translate-x-full opacity-0" : "translate-x-full opacity-0"
    }
    return "translate-x-0 opacity-100"
  }

  return (
    <>
                <Helmet>
                  {/* 1. CMP */}
      <script
        id="usercentrics-cmp"
        src="https://app.usercentrics.eu/browser-ui/latest/loader.js"
        data-settings-id="R7Xi1xeFRKhrKk"
        async
      />
      {/* 2. gtag */}
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=AW-17303305286"
      />
      <script>{`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-17303305286');
      `}</script>
      {/* 3a. GTM head */}
      <script>{`
        (function(w,d,s,l,i){
          w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
          j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-MBKBFC9M');
      `}</script>
                {/* Browser tab title */}
                <title>Exam Crusher | AIAT</title>

        {/* Basic SEO */}
        <meta
          name="description"
          content="AIAT’s Exam Crusher helps you master A-level, AP, and IB exams with AI-powered past papers, step-by-step solutions, and scoring strategies."
        />
        <meta
          name="keywords"
          content="A-level, AP, IB, exam prep, AI tutor, past papers, step-by-step solutions"
        />

        {/* Favicon */}
        <link rel="icon" href="/favicon.ico" />

        {/* Open Graph for Facebook, LinkedIn, etc. */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Exam Crusher | AIAT" />
        <meta
          property="og:description"
          content="AI-powered exam prep for A-level, AP, and IB: practice past papers, detailed solutions, and scoring strategies."
        />
        <meta property="og:url" content={window.location.href} />


        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Exam Crusher | AIAT" />
        <meta
          name="twitter:description"
          content="AI-powered exam prep for A-level, AP, and IB: practice past papers, detailed solutions, and scoring strategies."
        />
        <meta
          name="twitter:image"
          content="https://yourdomain.com/assets/social-homepage.png"
        />
      </Helmet>
      <div className="bg-black text-white">
        {/* Hero Section */}
        <div className="relative w-full min-h-screen flex flex-col justify-center items-center z-10">
          {/* Animated background elements - full width */}
          <div className="absolute inset-0 w-screen h-full z-0 overflow-hidden">
            <div
              className="absolute top-0 -left-20 h-64 w-64 rounded-full bg-red-600/10 blur-3xl animate-pulse"
              style={{ animationDuration: "8s" }}
            />
            <div
              className="absolute bottom-40 -right-20 h-64 w-64 rounded-full bg-blue-600/10 blur-3xl animate-pulse"
              style={{ animationDuration: "10s" }}
            />
            <div
              className="absolute top-1/2 left-1/3 h-40 w-40 rounded-full bg-purple-600/10 blur-3xl animate-pulse"
              style={{ animationDuration: "12s" }}
            />

            {/* Floating Icons */}
            <motion.div
              className="absolute top-20 right-20 text-white/10"
              animate={{
                y: [0, -20, 0],
                rotate: [0, 5, 0],
              }}
              transition={{
                duration: 6,
                repeat: Number.POSITIVE_INFINITY,
                ease: "easeInOut",
              }}
            >
              <Calculator size={60} />
            </motion.div>

            <motion.div
              className="absolute bottom-32 left-16 text-white/10"
              animate={{
                y: [0, 15, 0],
                rotate: [0, -5, 0],
              }}
              transition={{
                duration: 8,
                repeat: Number.POSITIVE_INFINITY,
                ease: "easeInOut",
              }}
            >
              <BookOpen size={50} />
            </motion.div>

          <motion.div
            className="absolute top-1/3 right-1/4 text-white/10"
            animate={{
              y: [0, -10, 0],
              x: [0, 10, 0],
            }}
            transition={{
              duration: 7,
              repeat: Number.POSITIVE_INFINITY,
              ease: "easeInOut",
            }}
          >
            <Lightbulb size={40} />
          </motion.div>
        </div>

        <div className="space-y-12">
          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl md:text-7xl font-bold relative text-center w-full"
          >
            <span className="relative inline-block">
              <span className="relative z-10 px-10">Exam Crusher</span>
              <motion.span
                initial={{ width: 0 }}
                animate={{ width: "100%" }}
                transition={{ delay: 0.8, duration: 0.6 }}
                className="absolute bottom-2 left-0 h-3 bg-red-500/50 rounded-full z-0"
              />
            </span>
            <motion.span
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              className="text-blue-400 relative"
            >
              <span className="relative z-10">AIAT</span>
              <motion.span
                initial={{ width: 0 }}
                animate={{ width: "100%" }}
                transition={{ delay: 1, duration: 0.6 }}
                className="absolute bottom-2 left-0 h-3 bg-blue-500/20 rounded-full z-0"
              />
            </motion.span>
          </motion.h1>

          <AnimatePresence mode="wait">
            {!showIntroDetail ? (
              // Simplified content for mobile devices
              <motion.div
                key="mobile"
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.5 }}
                className="relative mx-auto max-w-2xl"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-red-900/30 to-blue-900/30 rounded-xl blur-xl"></div>
                <motion.div
                  className="relative bg-black/40 backdrop-blur-md rounded-xl p-8 border border-white/10 shadow-2xl"
                  initial={{ y: 20 }}
                  animate={{ y: 0 }}
                  transition={{ delay: 0.2, duration: 0.5 }}
                >
                  <div className="flex items-center justify-center mb-6">
                    <GraduationCap className="text-blue-400 mr-3" size={32} />
                    <p className="text-lg text-white font-medium">
                      Your all-in-one AI-powered learning platform for A-level, AP, and IB success
                    </p>
                  </div>
                  <div className="flex flex-col items-center space-y-4">
                    <motion.div
                      className="flex items-center"
                      initial={{ x: -20, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      transition={{ delay: 0.3, duration: 0.5 }}
                    >
                      <Calculator className="text-red-400 mr-3" size={20} />
                      <span className="text-white">
                        <span className="text-red-400 font-semibold">A-level, AP & IB</span> Math
                      </span>
                    </motion.div>
                    <motion.div
                      className="flex items-center"
                      initial={{ x: -20, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      transition={{ delay: 0.4, duration: 0.5 }}
                    >
                      <Target className="text-red-400 mr-3" size={20} />
                      <span className="text-white">
                        <span className="text-red-400 font-semibold">Step-by-step</span> A-level, AP & IB solutions
                      </span>
                    </motion.div>
                    <motion.div
                      className="flex items-center"
                      initial={{ x: -20, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      transition={{ delay: 0.5, duration: 0.5 }}
                    >
                      <Sparkles className="text-blue-400 mr-3" size={20} />
                      <span className="text-white">
                        <span className="text-blue-400 font-semibold">Interactive</span> A-level, AP & IB learning
                      </span>
                    </motion.div>
                    <motion.div
                      className="flex items-center"
                      initial={{ x: -20, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      transition={{ delay: 0.6, duration: 0.5 }}
                    >
                      <Zap className="text-red-400 mr-3" size={20} />
                      <span className="text-white">
                        <span className="text-red-400 font-semibold">AI-powered</span> A-level, AP & IB assistance
                      </span>
                    </motion.div>
                  </div>
                </motion.div>
              </motion.div>
            ) : (
              // Detailed content for desktop
              <motion.div
                key="desktop"
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.5 }}
                className="relative w-screen max-w-none"
              >
                <div
                  className="absolute inset-0 w-full bg-gradient-to-r from-red-900/30 to-blue-900/30 blur-xl animate-pulse"
                  style={{ animationDuration: "8s" }}
                ></div>
                <motion.div
                  className="relative bg-black/60 backdrop-blur-md border-y border-white/10 shadow-2xl py-6 w-full"
                  initial={{ y: 20 }}
                  animate={{ y: 0 }}
                  transition={{ delay: 0.2, duration: 0.5 }}
                >
                  <div className="container mx-auto px-4 md:px-8 lg:px-16">
                    <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 justify-center">
                      <motion.div
                        className="lg:w-1/3 lg:border-r border-white/20 lg:pr-4"
                        initial={{ x: -20, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ delay: 0.3, duration: 0.5 }}
                      >
                        <h2 className="text-xl lg:text-2xl font-bold mb-3 text-white flex items-center justify-center lg:justify-start">
                          <Calculator className="text-red-400 mr-2" size={24} />
                          <span className="text-red-400">A-level</span> Excellence
                        </h2>
                        <ul className="space-y-2 mt-2 text-sm lg:text-base">
                          <motion.li
                            className="flex items-start"
                            initial={{ x: -20, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 0.4, duration: 0.5 }}
                          >
                            <Star className="text-red-400 mr-2 mt-1 flex-shrink-0" size={16} />
                            <span>
                              Master <span className="text-red-400 font-semibold">A-level Calculus</span>,{" "}
                              <span className="text-red-400 font-semibold">A-level Physics</span>, and{" "}
                              <span className="text-red-400 font-semibold">A-level Chemistry</span>
                            </span>
                          </motion.li>
                          <motion.li
                            className="flex items-start"
                            initial={{ x: -20, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 0.5, duration: 0.5 }}
                          >
                            <FileText className="text-red-400 mr-2 mt-1 flex-shrink-0" size={16} />
                            <span>
                              Comprehensive <span className="text-red-400 font-semibold">A-level past papers</span> and
                              exam preparation
                            </span>
                          </motion.li>
                          <motion.li
                            className="flex items-start"
                            initial={{ x: -20, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 0.6, duration: 0.5 }}
                          >
                            <Target className="text-red-400 mr-2 mt-1 flex-shrink-0" size={16} />
                            <span>
                              Step-by-step <span className="text-red-400 font-semibold">A-level solutions</span> with
                              detailed explanations
                            </span>
                          </motion.li>
                        </ul>
                      </motion.div>

                      <motion.div
                        className="lg:w-1/3 lg:border-r border-white/20 lg:px-4"
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.3, duration: 0.5 }}
                      >
                        <h2 className="text-xl lg:text-2xl font-bold mb-3 text-white flex items-center justify-center lg:justify-start">
                          <Trophy className="text-blue-400 mr-2" size={24} />
                          <span className="text-blue-400">AP</span> Mastery
                        </h2>
                        <ul className="space-y-2 mt-2 text-sm lg:text-base">
                          <motion.li
                            className="flex items-start"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.4, duration: 0.5 }}
                          >
                            <Zap className="text-blue-400 mr-2 mt-1 flex-shrink-0" size={16} />
                            <span>
                              Excel in <span className="text-blue-400 font-semibold">AP Calculus</span>,{" "}
                              <span className="text-blue-400 font-semibold">AP Physics</span>, and{" "}
                              <span className="text-blue-400 font-semibold">AP Chemistry</span>
                            </span>
                          </motion.li>
                          <motion.li
                            className="flex items-start"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.5, duration: 0.5 }}
                          >
                            <ChartBar className="text-blue-400 mr-2 mt-1 flex-shrink-0" size={16} />
                            <span>
                              Extensive <span className="text-blue-400 font-semibold">AP exam preparation</span> with
                              practice tests
                            </span>
                          </motion.li>
                          <motion.li
                            className="flex items-start"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.6, duration: 0.5 }}
                          >
                            <Target className="text-blue-400 mr-2 mt-1 flex-shrink-0" size={16} />
                            <span>
                              Targeted <span className="text-blue-400 font-semibold">AP scoring strategies</span> and
                              techniques
                            </span>
                          </motion.li>
                        </ul>
                      </motion.div>

                        <motion.div
                          className="lg:w-1/3 lg:pl-4"
                          initial={{ x: 20, opacity: 0 }}
                          animate={{ x: 0, opacity: 1 }}
                          transition={{ delay: 0.3, duration: 0.5 }}
                        >
                          <h2 className="text-xl lg:text-2xl font-bold mb-3 text-white flex items-center justify-center lg:justify-start">
                            <BookMarked className="text-green-400 mr-2" size={24} />
                            <span className="text-green-400">IB</span> Success
                          </h2>
                          <ul className="space-y-2 mt-2 text-sm lg:text-base">
                            <motion.li
                              className="flex items-start"
                              initial={{ x: 20, opacity: 0 }}
                              animate={{ x: 0, opacity: 1 }}
                              transition={{ delay: 0.4, duration: 0.5 }}
                            >
                              <Layers className="text-green-400 mr-2 mt-1 flex-shrink-0" size={16} />
                              <span>
                                Master <span className="text-green-400 font-semibold">IB Mathematics</span>,{" "}
                                <span className="text-green-400 font-semibold">IB Sciences</span>, and{" "}
                                <span className="text-green-400 font-semibold">IB Theory of Knowledge</span>
                              </span>
                            </motion.li>
                            <motion.li
                              className="flex items-start"
                              initial={{ x: 20, opacity: 0 }}
                              animate={{ x: 0, opacity: 1 }}
                              transition={{ delay: 0.5, duration: 0.5 }}
                            >
                              <PieChart className="text-green-400 mr-2 mt-1 flex-shrink-0" size={16} />
                              <span>
                                Complete <span className="text-green-400 font-semibold">IB Internal Assessment</span>{" "}
                                support and guidance
                              </span>
                            </motion.li>
                            <motion.li
                              className="flex items-start"
                              initial={{ x: 20, opacity: 0 }}
                              animate={{ x: 0, opacity: 1 }}
                              transition={{ delay: 0.6, duration: 0.5 }}
                            >
                              <Award className="text-green-400 mr-2 mt-1 flex-shrink-0" size={16} />
                              <span>
                                Comprehensive <span className="text-green-400 font-semibold">IB Diploma</span> preparation
                                resources
                              </span>
                            </motion.li>
                          </ul>
                        </motion.div>
                      </div>
                    </div>
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          <motion.p
            className="mt-6 text-center text-lg font-medium text-white max-w-xl mx-auto"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.2, duration: 0.5 }}
          >
            Sign up or use Guest Access to unlock powerful, free AI tools for your A-Level, IB, and AP courses!
          </motion.p>
          <motion.div
            className="flex flex-wrap justify-center gap-6 mt-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.5 }}
          >
            <motion.a
              href="#"
              className="relative overflow-hidden group px-8 py-3 rounded-full bg-gradient-to-r from-red-600 to-red-800 text-white font-bold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              onClick={(e) => {
                e.preventDefault()
                // Check if user is already authenticated
                if (typeof window !== "undefined" && (localStorage.getItem("token") || sessionStorage.getItem("token"))) {
                  navigate("/home")
                } else {
                  navigate("/login")
                }
              }}
            >
              <span className="relative z-10 flex items-center justify-center">
                <Users className="h-5 w-5 mr-2" />
                Signup/Login
              </span>
              <span className="absolute inset-0 bg-gradient-to-r from-red-700 to-pink-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
            </motion.a>
            <motion.button
              className="relative overflow-hidden group px-8 py-3 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 text-white font-bold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              onClick={handleGuestLogin}
            >
              <span className="relative z-10 flex items-center justify-center">
                <Rocket className="h-5 w-5 mr-2" />
                Guest Access
              </span>
              <span className="absolute inset-0 bg-gradient-to-r from-blue-600 to-purple-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
            </motion.button>
            <motion.button
              className="relative overflow-hidden group px-8 py-3 rounded-full bg-transparent border-2 border-white text-white font-bold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => window.scrollBy({ top: window.innerHeight * 0.7, behavior: "smooth" })}
            >
              <span className="relative z-10 flex items-center justify-center">
                <Lightbulb className="h-5 w-5 mr-2" />
                Learn More
              </span>
              <span className="absolute inset-0 bg-white bg-opacity-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
            </motion.button>
          </motion.div>


          <motion.div
            className="py-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl w-full"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, staggerChildren: 0.1 }}
          >
            <motion.button
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleGuestLoginChat}
              className="group relative bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 text-center hover:bg-slate-800/70 transition-all duration-300"
            >
              <motion.div
                className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-lg"
                whileHover={{ rotate: 5 }}
              >
                <MessageCircle className="w-8 h-8 text-white" />
              </motion.div>
              <h3 className="text-xl font-bold text-white mb-2 group-hover:text-purple-300 transition-colors">AI Tutor</h3>
              <p className="text-slate-400 text-sm group-hover:text-slate-300 transition-colors mb-3">Instant help for accurate solutions 24/7</p>
              <motion.div
                className="relative text-xs text-emerald-400 font-medium bg-gradient-to-r from-emerald-400/20 to-green-400/20 px-3 py-1 rounded-full border border-emerald-400/30 overflow-hidden"
                animate={{
                  boxShadow: [
                    "0 0 0 0 rgba(52, 211, 153, 0)",
                    "0 0 20px 5px rgba(52, 211, 153, 0.3)",
                    "0 0 0 0 rgba(52, 211, 153, 0)",
                  ],
                }}
                transition={{
                  duration: 2,
                  repeat: Number.POSITIVE_INFINITY,
                  ease: "easeInOut",
                }}
              >
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                  animate={{
                    x: ["-100%", "100%"],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Number.POSITIVE_INFINITY,
                    ease: "easeInOut",
                    repeatDelay: 0,
                  }}
                />
                <span className="relative z-10">Click for FREE access</span>
              </motion.div>
            </motion.button>

            <motion.button
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleGuestLoginPapers}
              className="group relative bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 text-center hover:bg-slate-800/70 transition-all duration-300"
            >
              <motion.div
                className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center shadow-lg"
                whileHover={{ rotate: 5 }}
              >
                <FileText className="w-8 h-8 text-white" />
              </motion.div>
              <h3 className="text-xl font-bold text-white mb-2 group-hover:text-purple-300 transition-colors">
                Past Papers
              </h3>
              <p className="text-slate-400 text-sm group-hover:text-slate-300 transition-colors mb-3">Free exam past paper with AI assistant</p>
              <motion.div
                className="relative text-xs text-emerald-400 font-medium bg-gradient-to-r from-emerald-400/20 to-green-400/20 px-3 py-1 rounded-full border border-emerald-400/30 overflow-hidden"
                animate={{
                  boxShadow: [
                    "0 0 0 0 rgba(52, 211, 153, 0)",
                    "0 0 20px 5px rgba(52, 211, 153, 0.3)",
                    "0 0 0 0 rgba(52, 211, 153, 0)",
                  ],
                }}
                transition={{
                  duration: 2,
                  repeat: Number.POSITIVE_INFINITY,
                  ease: "easeInOut",
                }}
              >
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                  animate={{
                    x: ["-100%", "100%"],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Number.POSITIVE_INFINITY,
                    ease: "easeInOut",
                    repeatDelay: 0,
                  }}
                />
                <span className="relative z-10">Click for FREE access</span>
              </motion.div>
            </motion.button>

            <motion.button
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleGuestLoginGrader}
              className="group relative bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 text-center hover:bg-slate-800/70 transition-all duration-300"
            >
              <motion.div
                className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-red-500 to-orange-600 flex items-center justify-center shadow-lg"
                whileHover={{ rotate: 5 }}
              >
                <GraduationCap className="w-8 h-8 text-white" />
              </motion.div>
              <h3 className="text-xl font-bold text-white mb-2 group-hover:text-purple-300 transition-colors">
                Auto Grader
              </h3>
              <p className="text-slate-400 text-sm group-hover:text-slate-300 transition-colors mb-3">Instant feedback on exam by uploading images</p>
              <motion.div
                className="relative text-xs text-emerald-400 font-medium bg-gradient-to-r from-emerald-400/20 to-green-400/20 px-3 py-1 rounded-full border border-emerald-400/30 overflow-hidden"
                animate={{
                  boxShadow: [
                    "0 0 0 0 rgba(52, 211, 153, 0)",
                    "0 0 20px 5px rgba(52, 211, 153, 0.3)",
                    "0 0 0 0 rgba(52, 211, 153, 0)",
                  ],
                }}
                transition={{
                  duration: 2,
                  repeat: Number.POSITIVE_INFINITY,
                  ease: "easeInOut",
                }}
              >
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                  animate={{
                    x: ["-100%", "100%"],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Number.POSITIVE_INFINITY,
                    ease: "easeInOut",
                    repeatDelay: 0,
                  }}
                />
                <span className="relative z-10">Click for FREE access</span>
              </motion.div>
            </motion.button>

            <motion.button
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleGuestLoginQuiz}
              className="group relative bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 text-center hover:bg-slate-800/70 transition-all duration-300"
            >
              <motion.div
                className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center shadow-lg"
                whileHover={{ rotate: 5 }}
              >
                <Zap className="w-8 h-8 text-white" />
              </motion.div>
              <h3 className="text-xl font-bold text-white mb-2 group-hover:text-purple-300 transition-colors">
                Quiz Maker
              </h3>
              <p className="text-slate-400 text-sm group-hover:text-slate-300 transition-colors mb-3">Custom practice with real exam styling</p>
              <motion.div
                className="relative text-xs text-emerald-400 font-medium bg-gradient-to-r from-emerald-400/20 to-green-400/20 px-3 py-1 rounded-full border border-emerald-400/30 overflow-hidden"
                animate={{
                  boxShadow: [
                    "0 0 0 0 rgba(52, 211, 153, 0)",
                    "0 0 20px 5px rgba(52, 211, 153, 0.3)",
                    "0 0 0 0 rgba(52, 211, 153, 0)",
                  ],
                }}
                transition={{
                  duration: 2,
                  repeat: Number.POSITIVE_INFINITY,
                  ease: "easeInOut",
                }}
              >
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                  animate={{
                    x: ["-100%", "100%"],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Number.POSITIVE_INFINITY,
                    ease: "easeInOut",
                    repeatDelay: 0,
                  }}
                />
                <span className="relative z-10">Click for FREE access</span>
              </motion.div>
            </motion.button>
          </motion.div>
        </div>

      {/* Stats Section */}
      <div className="py-16 bg-gradient-to-r from-gray-900 to-black">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className="text-center"
              >
                <div className="flex justify-center mb-4">
                  <div className="p-4 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full">
                    <stat.icon className="text-white" size={32} />
                  </div>
                </div>
                <div className="text-3xl font-bold text-white mb-2">{stat.number}</div>
                <div className="text-gray-400">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Animated Text Section */}
      <div className="py-20 text-center relative">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="grid grid-cols-8 gap-4 h-full">
            {Array.from({ length: 32 }).map((_, i) => (
              <motion.div
                key={i}
                className="flex items-center justify-center"
                animate={{
                  opacity: [0.1, 0.3, 0.1],
                  scale: [1, 1.1, 1],
                }}
                transition={{
                  duration: 3,
                  delay: i * 0.1,
                  repeat: Number.POSITIVE_INFINITY,
                  ease: "easeInOut",
                }}
              >
                {i % 4 === 0 && <Calculator size={24} />}
                {i % 4 === 1 && <BookOpen size={24} />}
                {i % 4 === 2 && <Lightbulb size={24} />}
                {i % 4 === 3 && <Trophy size={24} />}
              </motion.div>
            ))}
          </div>
        </div>

        {lines.map((text, index) => (
          <motion.div
            key={index}
            ref={(el) => (textRefs.current[index] = el)}
            initial={{ opacity: 0, y: 20 }}
            animate={{
              opacity: visible[index] ? 1 : 0,
              y: visible[index] ? 0 : 20,
            }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="text-6xl font-semibold mb-6 relative z-10"
          >
            <span className="text-blue-400">{text[0]}</span>
            {text.slice(1)}
          </motion.div>
        ))}
      </div>

      {/* Feature Highlights */}
      <div className="py-16 bg-gradient-to-r from-blue-900/20 to-purple-900/20">
        <div className="container mx-auto px-6">
          <motion.h2
            className="text-4xl font-bold text-center mb-12 text-white flex items-center justify-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Sparkles className="mr-4 text-yellow-400" size={40} />
            Why Choose Exam Crusher AIAT?
          </motion.h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {featureHighlights.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className="text-center p-6 bg-black/30 rounded-xl border border-white/10 hover:border-blue-500/50 transition-all duration-300"
              >
                <div className="flex justify-center mb-4">
                  <div className="p-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full">
                    <feature.icon className="text-white" size={24} />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                <p className="text-gray-400">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Cutting-edge Technology Cards */}
      <div className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <motion.h2
            className="text-4xl font-bold text-center mb-12 text-white flex items-center justify-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Cpu className="mr-4 text-blue-400" size={40} />
            Cutting-Edge Technology Powering Your Success
          </motion.h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {techCards.map((card, index) => (
              <motion.div
                key={index}
                ref={(el) => (techCardRefs.current[index] = el)}
                initial={{ opacity: 0, y: 30 }}
                animate={{
                  opacity: techCardsVisible[index] ? 1 : 0,
                  y: techCardsVisible[index] ? 0 : 30,
                }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                className="relative bg-gradient-to-br from-gray-900 to-gray-800 rounded-xl p-6 border border-gray-700 hover:border-blue-500 transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/20 overflow-hidden"
              >
                {/* Background Icon */}
                <div className="absolute top-4 right-4 opacity-10">
                  <card.bgIcon size={80} />
                </div>

                <div className="flex items-center mb-4 relative z-10">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg mr-4">
                    <card.icon className="text-white" size={24} />
                  </div>
                  <h3 className="text-xl font-bold text-white">{card.title}</h3>
                </div>
                <p className="text-gray-300 leading-relaxed relative z-10">{card.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Content Sections */}
      <div className="py-10">
        {sections.map((section, index) => (
          <div key={index} ref={sectionRefs.current[index]} className="py-8 overflow-hidden">
            <div
              className={`max-w-[90vw] mx-auto px-6 py-12 rounded-2xl bg-gradient-to-r ${section.gradient} shadow-2xl 
                transition-all duration-700 ease-in-out transform ${getAnimationClass(index, visibleSections[index])} relative overflow-hidden`}
            >
              {/* Background Decorative Icon */}
              <div className="absolute top-8 right-8 opacity-10">
                <section.decorativeIcon size={120} />
              </div>

              <div className="flex flex-col md:flex-row items-center relative z-10">
                <div className="md:w-1/4 mb-8 md:mb-0 flex justify-center">
                  <div className="p-6 bg-white/10 rounded-full backdrop-blur-sm">
                    <section.icon className="text-8xl text-white" />
                  </div>
                </div>
                <div className="md:w-3/4 md:pl-10">
                  <h2 className="text-3xl md:text-4xl font-bold mb-6 flex items-center">
                    <section.decorativeIcon className="mr-4" size={32} />
                    {section.name}
                  </h2>
                  <p className="text-lg md:text-xl leading-relaxed mb-6">{section.content}</p>
                  <ul className="mb-8 space-y-2">
                    {section.features.map((feature, i) => (
                      <li key={i} className="flex items-center">
                        <CheckCircle className="w-5 h-5 mr-2 text-white" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-8">
                    <a
                      href={section.path}
                      className="bg-white text-gray-900 hover:bg-gray-100 font-semibold py-2 px-6 rounded-full text-lg transition-all duration-300 hover:scale-105 inline-flex items-center"
                    >
                      <Rocket className="mr-2" size={20} />
                      Discover More
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Footer CTA */}
      <div className="bg-gradient-to-r from-blue-900 to-purple-900 py-20 mt-10 relative overflow-hidden">
        {/* Background Icons */}
        <div className="absolute inset-0 opacity-5">
          <div className="grid grid-cols-6 gap-8 h-full">
            {Array.from({ length: 24 }).map((_, i) => (
              <motion.div
                key={i}
                className="flex items-center justify-center"
                animate={{
                  rotate: [0, 360],
                  scale: [1, 1.2, 1],
                }}
                transition={{
                  duration: 10,
                  delay: i * 0.2,
                  repeat: Number.POSITIVE_INFINITY,
                  ease: "linear",
                }}
              >
                {i % 6 === 0 && <GraduationCap size={32} />}
                {i % 6 === 1 && <Trophy size={32} />}
                {i % 6 === 2 && <Star size={32} />}
                {i % 6 === 3 && <Target size={32} />}
                {i % 6 === 4 && <Award size={32} />}
                {i % 6 === 5 && <Sparkles size={32} />}
              </motion.div>
            ))}
          </div>
        </div>

        <div className="container mx-auto px-6 text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="flex items-center justify-center mb-8"
          >
            <Rocket className="text-yellow-400 mr-4" size={48} />
            <h2 className="text-4xl font-bold">Ready to Transform Your A-level, AP, and IB Experience?</h2>
          </motion.div>

          <p className="text-xl max-w-3xl mx-auto mb-10 flex items-center justify-center flex-wrap">
            <Users className="mr-2 text-blue-300" size={24} />
            Join thousands of A-level, AP, and IB students and educators who have already elevated their academic
            journey with our AI-powered platform. Experience the future of A-level, AP, and IB education with
            personalized learning paths, comprehensive A-level, AP, and IB resources, and cutting-edge technology
            designed specifically for A-level, AP, and IB success. Whether you're preparing for A-level mathematics, AP
            sciences, IB subjects, or any other A-level, AP, or IB subject, our platform provides the tools and support
            you need to excel in your A-level, AP, and IB examinations.
          </p>

          <motion.a
            href="/register"
            className="bg-white text-blue-900 hover:bg-blue-50 font-bold py-3 px-10 rounded-full text-xl transition-all duration-300 transform hover:scale-105 inline-flex items-center"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.98 }}
          >
            <Trophy className="mr-2" size={24} />
            Start Your A-level, AP & IB Success Journey
          </motion.a>
        </div>
      </div>
    </div>
    </>
  )
}

export default MathPlatformIntro
